import type { HelpdeskManagedFieldType } from "@repo/shared-types/helpdesk";
import { optionalRouteSearchString } from "../../shared/web/route-search.ts";

export type StandardManagedFieldType = Exclude<HelpdeskManagedFieldType, "externalResource">;
export type ManagedFieldStatus = "archived" | "draft" | "published";
export type ManagedFieldSearch = {
  tenantId?: string;
  departmentGroup?: string;
  search?: string;
  scope?: string;
  status?: ManagedFieldStatus;
  type?: HelpdeskManagedFieldType;
};
export type AdminManagedFieldSearch = Omit<ManagedFieldSearch, "departmentGroup" | "scope">;

export const standardManagedFieldTypes: readonly StandardManagedFieldType[] = ["text", "textarea", "choice", "person", "email", "number", "date", "dateTime", "confirmation", "attachment", "group"];

const managedFieldTypes: readonly HelpdeskManagedFieldType[] = [...standardManagedFieldTypes, "externalResource"];
const managedFieldStatuses: readonly ManagedFieldStatus[] = ["draft", "published", "archived"];

const isManagedFieldStatus = (value: unknown): value is ManagedFieldStatus => managedFieldStatuses.some((status) => status === value);
const isManagedFieldType = (value: unknown): value is HelpdeskManagedFieldType => managedFieldTypes.some((type) => type === value);

export const managedFieldSearch = (search: Record<string, unknown>): ManagedFieldSearch => {
  const result: ManagedFieldSearch = {};
  const tenantId = optionalRouteSearchString(search.tenantId);
  if (tenantId) result.tenantId = tenantId;
  const departmentGroup = optionalRouteSearchString(search.departmentGroup);
  const searchValue = optionalRouteSearchString(search.search);
  const scope = optionalRouteSearchString(search.scope);
  if (departmentGroup) result.departmentGroup = departmentGroup;
  if (searchValue) result.search = searchValue;
  if (scope) result.scope = scope;
  if (isManagedFieldStatus(search.status)) result.status = search.status;
  if (isManagedFieldType(search.type)) result.type = search.type;
  return result;
};

export const adminManagedFieldSearch = (search: Record<string, unknown>): AdminManagedFieldSearch => {
  const { departmentGroup: _departmentGroup, scope: _scope, ...result } = managedFieldSearch(search);
  return result;
};
